import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_candles: FaireCategoryEntity = {
  token: "cat_home-decor-candles",
  type: "category",
  name: "Candles & holders",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/candles-holders",
  childCategoryTokens: [
    "cat_candles-holders-all",
    "cat_candles-all",
    "cat_candles-holders-matches",
    "cat_candles-warmers",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
